import {Component, inject, OnInit, signal} from '@angular/core'
import {HttpClient} from '@angular/common/http'
import {environment} from '../../../environments/environment'
import {IloginResponse} from '../../1-application/types'
import {ActivatedRoute} from '@angular/router'
import {filter} from 'rxjs'
import {WINDOW} from '../../0-general/providers'
import {MatButton} from '@angular/material/button'
import {MatProgressBar} from '@angular/material/progress-bar'

@Component({
  selector: 'aku-login',
  templateUrl: './login.html',
  styleUrl: './login.scss',
  imports: [
    MatButton,
    MatProgressBar
  ],
  providers: [{provide: WINDOW, useValue: globalThis}]
})
export class Login implements OnInit {
  /* v8 ignore next @preserve */
  public readonly endpoint = signal<string>('')
  /* v8 ignore next @preserve */
  public readonly state = signal<string>('')
  /* v8 ignore next @preserve */
  public readonly clientId = signal<string>('')
  /* v8 ignore next @preserve */
  public readonly redirectUri = signal<string>('')
  /* v8 ignore next @preserve */
  public readonly scope = signal<string>('')

  private readonly http = inject(HttpClient)

  private readonly route = inject(ActivatedRoute)

  private readonly window = inject(WINDOW)

  public ngOnInit() {
    localStorage.setItem('service', 'gitlab')
    localStorage.setItem('destination', `${this.window.location.origin}/#/logged-in`)
    localStorage.setItem('nonce', 'for-future-use')

    this.http.post<IloginResponse>(`${environment.apiUrl}/login`, {
      service: this.route.snapshot.queryParamMap.get('service') ??
        localStorage.getItem('service'),
      host: this.window.location.host
    })
      .subscribe(res => {
        this.endpoint.set(res.authorization_endpoint)
        this.state.set(res.state)
        this.redirectUri.set(res.redirect_uri)
        this.clientId.set(res.client_id)
        this.scope.set(res.scope)
      })

    this.route.queryParamMap
      .pipe(filter(params => params.has('destination')))
      .subscribe(params => {
        localStorage.setItem('service', params.get('service')!)
        localStorage.setItem('destination', params.get('destination')!)
        localStorage.setItem('nonce', params.get('nonce')!)
      })
  }
}
